/**
 * Created by ori on 28/07/16.
 */
import React from 'react'
export default () => {
    return (
        <div>404</div>
    );
};


// WEBPACK FOOTER //
// ./src/js/pages/NoMatch.js